import React, { Component, useRef, useState } from 'react';
// import css from 'Minmax.css'
// import './Minmax.css';
import jsPDF from 'jspdf';
import html2canvas from "html2canvas";
import { FormControl, FormLabel, FormControlLabel, Checkbox, FormHelperText, Paper, Chip, Card, CardHeader, CardMedia, CardContent, CardActions, Avatar } from '@material-ui/core';

const domToImage = require('dom-to-image');
const domToPdf = require('dom-to-pdf');


const Minmax = props => {

    const upload = e => {

        var element = document.getElementById('signature');
        // var options = {
        //   filename:  sessionStorage.getItem('BarCodeStr')  + '.pdf',
        // };
        // var pdf = new jsPDF();
        var pdf = new jsPDF('p', 'pt', 'a4');


        // var element = document.getElementById('test');
        var options = {
            filename: 'test.pdf'
        };
        domToPdf(element, options, function (pdf) {
            console.log('done');
        });
    }

    const getPDF = (e) => {

        var HTML_Width = 1070;
        var HTML_Height = 4542;
        var top_left_margin = '309';
        var PDF_Width = 1070;
        var PDF_Height = 1514;
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;

        var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;
        var element = document.getElementById('signature');
        // console.log(totalPDFPages)

        // html2canvas(element, { allowTaint: true, imageTimeout: 0, }).then(function (canvas) {
        //     canvas.getContext('2d');

        //     console.log(canvas.height + "  " + canvas.width);


        //     var imgData = canvas.toDataURL("image/jpeg", 1.0);
        //     var pdf = new jsPDF('p', 'pt', [PDF_Width, PDF_Height]);
        //     pdf.addImage(imgData, 'JPG', 0, 0, canvas_image_width, canvas_image_height);


        //     for (var i = 1; i <= totalPDFPages; i++) {
        //         pdf.addPage(PDF_Width, PDF_Height);
        //         pdf.addImage(imgData, 'JPG', 0, -(PDF_Height * i) + (0 * 4), canvas_image_width, canvas_image_height);
        //     }

        //     pdf.save("HTML-Document.pdf");
        // });
        // var scale = 2;
        domToImage.toPng(element,
            {
                scale: 5
                //     width: 1070 * scale,
                //     height: 4542 * scale,
                //     style: {
                //         transform: 'scale(' + scale + ')',
                //         transformOrigin: 'top left'
                //     }
            }
        ).then(pageData => {
            let contentWidth = element.clientWidth;
            let contentHeight = element.clientHeight;
            console.log(element.clientWidth)
            console.log(element.clientHeight)
            //一页pdf显示html页面生成的canvas高度;
            let pageHeight = contentWidth / 592.28 * 841.89;
            //未生成pdf的html页面高度
            let leftHeight = contentHeight;
            //页面偏移
            let position = 0;
            //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
            let imgWidth = 595.28;
            let imgHeight = 592.28 / contentWidth * contentHeight;
            let pdf = new jsPDF('', 'pt', 'a4');

            //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
            //当内容未超过pdf一页显示的范围，无需分页
            if (leftHeight < pageHeight) {
                pdf.addImage(pageData, 'JPEG', -120, 0, imgWidth, imgHeight);
            } else {
                while (leftHeight > 0) {
                    pdf.addImage(pageData, 'JPEG', -120, position, imgWidth, imgHeight)
                    leftHeight -= pageHeight;
                    position -= 841.89;
                    //避免添加空白页
                    if (leftHeight > 0) {
                        pdf.addPage();
                    }
                }
            }

            pdf.save('content.pdf');
        });
    };

    return (
        <>
            <button onClick={getPDF}>CLICK</button>
            <article class="report reportPrint" id="signature">
                <section class="print-Box A4-nomodify">
                    <h1>測試</h1>
                    <FormControlLabel
                        control={<Checkbox checked={true} name="female" color="secondary" />}
                        label="女"
                    />
                </section>
                <section class="print-Box A4-nomodify">OOO</section>
                <section class="print-Box A4-nomodify">YYY</section>
            </article>
        </>
    )
}

export default Minmax;